import CommonDetailsSheet from "@/components/common/details/DetailsSheet";
import Map from "@/components/map/Map";
import { Badge } from "@/components/ui/badge";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Transfer } from "@/interface/entityInterface";
import { Car, Clock, Euro, MapPin, Notebook, StretchVertical } from "lucide-react";
import { Dispatch, FC, SetStateAction } from "react";

const libraries = ["places"];

interface Props {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  transfer: Transfer | null;
}

const TransferDetails: FC<Props> = ({ isOpen, setOpen, transfer }) => {
  if (!isOpen || !transfer) return;
  return (
    <Sheet open={isOpen} onOpenChange={setOpen}>
      <SheetContent className="p-4 sm:p-5 max-h-[90vh] overflow-auto" side="bottom">
        <SheetTitle className="hidden"></SheetTitle>
        <div className="grid lg:grid-cols-2 gap-4 h-full">
          <Map
            libraries={libraries}
            coordinates={{
              pickup_latitude: transfer.pickup_latitude || 0,
              pickup_longitude: transfer.pickup_longitude || 0,
              dropoff_latitude: transfer.dropoff_latitude || 0,
              dropoff_longitude: transfer.dropoff_longitude || 0
            }}
          />
          <div>
            <div>
              <div>
                <p className="text-lg sm:text-4xl font-bold">Transfer details</p>
              </div>
            </div>
            <div className="flex items-center gap-x-3">
                <div className="flex gap-2 mt-5">
              <Badge
                variant="outline"
                className="flex gap-1 px-1.5 text-muted-foreground [&_svg]:size-3 text-capitalize"
              >
                {transfer?.type}
              </Badge>
            </div>
            <div className="flex gap-2 mt-5">
              <Badge
                variant="outline"
                className="flex gap-1 px-1.5 text-muted-foreground [&_svg]:size-3 text-capitalize"
              >
                {transfer?.transfer_way}
              </Badge>
            </div>
            </div>
            <div className="mt-7">
              <h2 className="text-lg font-semibold mb-4 mt-5">Transfer Info</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <div className="bg-muted rounded-xl p-4 text-center">
                  <MapPin className="w-5 h-5 mx-auto text-muted-foreground mb-2" />
                  <p className="text-[12px] text-muted-foreground mb-1">
                    Pickup location
                  </p>
                  <p className="text-[18px] font-medium line-clamp-2">
                    {transfer.pickup_location || "-"}
                  </p>
                </div>
                <div className="bg-muted rounded-xl p-4 text-center">
                    <MapPin className="w-5 h-5 mx-auto text-muted-foreground mb-2" />
                  <p className="text-[12px] text-muted-foreground mb-1">
                    Dropoff location
                  </p>
                  <p className="text-[18px] font-medium line-clamp-2">
                    {transfer?.dropoff_location || "-"}
                  </p>
                </div>
                <div className="bg-muted rounded-xl p-4 text-center">
                  <Euro className="w-5 h-5 mx-auto text-muted-foreground mb-2" />
                  <p className="text-[12px] text-muted-foreground mb-1">
                    Total price
                  </p>
                  <p className="text-[18px] font-medium">
                    {transfer?.price} {transfer.currency}
                  </p>
                </div>
                <div className="bg-muted rounded-xl p-4 text-center">
                  <Car className="w-5 h-5 mx-auto text-muted-foreground mb-2" />
                  <p className="text-[12px] text-muted-foreground mb-1">
                    Vehicle class
                  </p>
                  <p className="text-[18px] font-medium capitalize">
                    {transfer.vehicle_class || "-"}
                  </p>
                </div>
                <div className="bg-muted rounded-xl p-4 text-center">
                  <StretchVertical className="w-5 h-5 mx-auto text-muted-foreground mb-2" />
                  <p className="text-[12px] text-muted-foreground mb-1">
                    Distance
                  </p>
                  <p className="text-[18px] font-medium">
                    {transfer?.distance ?  `${transfer?.distance} km` : "-"}
                  </p>
                </div>
                <div className="bg-muted rounded-xl p-4 text-center">
                  <Clock className="w-5 h-5 mx-auto text-muted-foreground mb-2" />
                  <p className="text-[12px] text-muted-foreground mb-1">
                    Duration
                  </p>
                  <p className="text-[18px] font-medium">
                    {transfer?.duration || "-"}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <p className="text-lg font-semibold mt-5">Notes</p>
              <p>{transfer?.notes ? transfer?.notes : "-"}</p>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default TransferDetails;
